module.exports = __webpack_public_path__ + "img/credits.60acf8eb.svg";